/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Icons } from "../../../components/icons";

import fetchData from "../../../utils/api";
import { User } from "lucide-react";
import { Label } from "../../../components/ui/label";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../components/ui/accordion";
import FormError from "../../../components/FormError";
import { Input } from "../../../components/ui/input";
import { Formik } from "formik";
import DropDownList from "../../../components/DropDownList";
import { Config } from "../../../utils/config";
import { Button } from "../../../components/ui/button";
import { ContactFormValidation } from "./Validation";
import { useTranslation } from "react-i18next";

export default function CartAccordionItem1({
  id,
  cartList,
  isLoading,
  setIsLoading,
  handleCartList,
  handleAccordionClick,
  authToken,
  ssoUserDetails,
}) {
  const { t } = useTranslation();
  const cachedTelephone = localStorage.getItem("telephone");
  return (
    <AccordionItem value="item-1">
      <AccordionTrigger>
        <div className="flex space-x-3">
          <div>
            <User />
          </div>
          <div>{t("cart.contact.title")}</div>
        </div>
      </AccordionTrigger>
      {ssoUserDetails ? (
        <Formik
          enableReinitialize={true}
          initialValues={{
            first_name:
              cartList?.contactDetails?.first_name ??
              ssoUserDetails.first_name ??
              "",
            last_name:
              cartList?.contactDetails?.last_name ??
              ssoUserDetails.last_name ??
              "",
            email: ssoUserDetails.email ?? "",
            telephone: cartList?.contactDetails?.telephone
              ? cartList?.contactDetails?.telephone
              : ssoUserDetails?.mobile
              ? ssoUserDetails?.mobile?.split(" ")[1]
              : cachedTelephone?.split(" ")[1],
            country_code: cartList?.contactDetails?.country_code
              ? cartList?.contactDetails?.country_code
              : ssoUserDetails?.mobile
              ? ssoUserDetails?.mobile.split(" ")[0]
              : cachedTelephone?.split(" ")[0] ??
                Config.env.app.country_code[0].value,
          }}
          validationSchema={ContactFormValidation}
          onSubmit={async (values) => {
            setIsLoading(true);

            const cachedCart = localStorage.getItem("cart");
            try {
              const body: any = {
                cart_id: cachedCart,
                first_name: values.first_name,
                last_name: values.last_name,
                email: values.email,
                telephone: values.telephone,
                country_code: values.country_code,
              };
              const res = await fetchData({
                url: "cart/contact",
                method: "POST",
                body,
                token: authToken,
              });
              if (res.status_code === 200) {
                setIsLoading(false);
                handleCartList();
                handleAccordionClick("item-2");
              }
              localStorage.setItem(
                "telephone",
                `${values.country_code} ${values.telephone}`
              );
            } catch (error) {
              console.log("error", error);
            }
          }}
        >
          {({ errors, touched, setFieldValue, values, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <AccordionContent className="grid p-2 gap-2">
                <div className="flex w-full justify-between gap-2">
                  <div className="grid gap-2 w-full">
                    <Label className="text-left" htmlFor="first_name">
                      {t("cart.contact.form.first_name")}
                    </Label>
                    <div>
                      <Input
                        id="first_name"
                        placeholder={t(
                          "cart.contact.form.first_name_placeholder"
                        )}
                        value={values.first_name}
                        onChange={(e: any) => {
                          setFieldValue("first_name", e.target.value, true);
                        }}
                        disabled={isLoading}
                      />
                      {errors.first_name && touched.first_name ? (
                        <FormError msg={t(errors.first_name as string)} />
                      ) : null}
                    </div>
                  </div>
                  <div className="grid gap-2 w-full">
                    <Label className="text-left" htmlFor="last_name">
                      {t("cart.contact.form.last_name")}
                    </Label>
                    <div>
                      <Input
                        id="last_name"
                        placeholder={t(
                          "cart.contact.form.last_name_placeholder"
                        )}
                        value={values.last_name}
                        onChange={(e: any) => {
                          setFieldValue("last_name", e.target.value, true);
                        }}
                        disabled={isLoading}
                      />
                      {errors.last_name && touched.last_name ? (
                        <FormError msg={t(errors.last_name as string)} />
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="grid gap-2 w-full">
                  <Label className="text-left" htmlFor="email">
                    {t("cart.contact.form.email")}
                  </Label>
                  <div>
                    <Input
                      id="email"
                      placeholder={t("cart.contact.form.email_placeholder")}
                      value={values.email}
                      onChange={(e: any) => {
                        setFieldValue("email", e.target.value, true);
                      }}
                      disabled
                    />
                    {errors.email && touched.email ? (
                      <FormError msg={t(errors.email as string)} />
                    ) : null}
                  </div>
                </div>
                <div className="grid gap-2 w-full">
                  <Label className="text-left" htmlFor="telephone">
                    {t("cart.contact.form.telephone")}
                  </Label>
                  <div className="flex gap-2">
                    <div className="w-[150px]">
                      <DropDownList
                        id="country_code"
                        label={t("cart.contact.form.country_code")}
                        placeholder={t(
                          "cart.contact.form.country_code_placeholder"
                        )}
                        data={Config.env.app.country_code}
                        value={values.country_code}
                        defaultValue={Config.env.app.country_code[0]}
                        onValueChange={(e: any) => {
                          setFieldValue("country_code", e, true);
                        }}
                        disabled={isLoading}
                        additionalInfo={true}
                      />
                    </div>
                    <Input
                      type="number"
                      id="telephone"
                      value={values.telephone}
                      onChange={(e: any) => {
                        setFieldValue("telephone", e.target.value, true);
                      }}
                      disabled={isLoading}
                      placeholder={t("cart.contact.form.telephone_placeholder")}
                    />
                  </div>
                  {errors.telephone && touched.telephone ? (
                    <FormError msg={t(errors.telephone as string)} />
                  ) : null}
                </div>
                <div className="flex justify-between w-full">
                  <div>
                    <Button
                      type="button"
                      variant={"ghost"}
                      onClick={() => {
                        window.location.href = `${Config.env.app.sso_url}/profile`;
                      }}
                    >
                      {t("manage_account")}
                    </Button>
                  </div>
                  <div>
                    <Button disabled={isLoading} type="submit">
                      {isLoading && (
                        <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
                      )}
                      {t("save")}
                    </Button>
                  </div>
                </div>
              </AccordionContent>
            </form>
          )}
        </Formik>
      ) : (
        <AccordionContent className="grid p-2 gap-2">
          <Button
            onClick={() =>
              (window.location.href = `${Config.env.app.sso_url}/sign-in/?return_url=${window.location.href}&return_token=true`)
            }
          >
            {isLoading && (
              <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
            )}
            {t("login")}
          </Button>
        </AccordionContent>
      )}
    </AccordionItem>
  );
}
